import * as $ from 'jquery';
import { getCookie, setCookie } from "../../js/utils";

class geoLocation {
  init = () => {
    const geoLocationModal: HTMLButtonElement = document.querySelector('.resero-modal.resero-modal-location');
    
    if (!geoLocationModal) {
      return;
    }
    $('body').addClass('resero-modal-open');
    $(geoLocationModal).removeClass("resero-modal--hidden");

    function handlePopUpClose () {
      setCookie("cp_closed", 'true', 30);
      $('body').removeClass('resero-modal-open')
      $(geoLocationModal).addClass("resero-modal--hidden");
    }

    $(".resero-modal__location .button, .resero-modal__close:not('.resero-modal__custom-close'), .resero-modal__heading__desc a, .resero-modal__region__item .button:not('.-active')").on("click", handlePopUpClose);

  };

}

const geoLocationInstance = new geoLocation();
geoLocationInstance.init();

export { geoLocation, geoLocationInstance };